// ---------------------------------------------------------------------------
// HOTEL DESK - GLOBAL DESIGN TOKENS
// Single source of truth for the application's visual language. Every UI
// component and page consumes these - never hard-code a colour, radius,
// shadow or spacing value in a page again.
// ---------------------------------------------------------------------------

/** Brand + semantic colours. */
export const color = {
  primary: '#0F172A',
  accent: '#2563EB',
  accentHover: '#1D4ED8',
  accentSoft: '#EFF6FF',

  success: '#22C55E',
  successSoft: '#F0FDF4',
  warning: '#F59E0B',
  warningSoft: '#FFFBEB',
  danger: '#EF4444',
  dangerSoft: '#FEF2F2',
  info: '#0EA5E9',
  infoSoft: '#F0F9FF',

  bg: '#F8FAFC',
  surface: '#FFFFFF',
  surfaceAlt: '#F8FAFC',

  text: '#0F172A',
  textMuted: '#64748B',
  textFaint: '#94A3B8',

  border: '#E2E8F0',
  borderStrong: '#CBD5E1',
};

/** 4px base spacing scale. */
export const space = { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32 };

/** Corner radii - 12px is the product standard for cards. */
export const radius = { sm: 6, md: 8, lg: 12, pill: 999 };

/** Soft, layered shadows - never heavy or coloured. */
export const shadow = {
  none: 'none',
  sm: '0 1px 2px rgba(15,23,42,0.04)',
  card: '0 1px 3px rgba(15,23,42,0.06), 0 1px 2px rgba(15,23,42,0.04)',
  raised: '0 4px 12px rgba(15,23,42,0.08)',
  overlay: '0 12px 28px rgba(15,23,42,0.12)',
};

/** Typography scale - Inter, already loaded globally in index.css. */
export const font = {
  family: "'Inter', 'Manrope', -apple-system, 'Segoe UI', sans-serif",
  pageTitle: { fontSize: 18, fontWeight: 700, letterSpacing: -0.2 },
  sectionTitle: { fontSize: 14, fontWeight: 700 },
  label: { fontSize: 12, fontWeight: 600 },
  body: { fontSize: 13, fontWeight: 400 },
  helper: { fontSize: 11.5, fontWeight: 400 },
  kpiValue: { fontSize: 22, fontWeight: 800, letterSpacing: -0.4 },
};

/** Fixed control height - keeps every filter/button on one crisp line. */
export const control = { height: 36 };

const tokens = { color, space, radius, shadow, font, control };
export default tokens;